import { createContext } from 'react'

export const SirenContext = createContext()
